export default function Aviso(){
    return(
        <div className="display-flex divAviso" key={"divA"}>
            <span className="inegi-alert imgAviso"></span>
            <span className="txtAviso">Por el momento no existen Documentos relacionados con la opción seleccionada</span>
        </div>
    )
}